import { Spinner } from 'app/components/Spinner';
import React, { createContext, useEffect, useContext, useState } from 'react';
import { LoadingContainer } from './styles';
import { AppHttpService } from '../../services';
import { IAppContext } from './app.interfaces';

export const AppContext = createContext<IAppContext>({} as IAppContext);

export interface IAppContextProviderProps {
  children?: React.ReactNode;
}

export const AppContextProvider = ({ children }: IAppContextProviderProps) => {
  const [app, setApp] = useState<IAppContext>();

  useEffect(() => {
    const appService = new AppHttpService();
    appService.getApp().then((appResponse) => {
      const { data: appData } = appResponse;
      const root = document.querySelector<HTMLHtmlElement>(':root');
      if (root)
        root.style.setProperty(
          '--primary',
          appData?.primary_color ?? '#806DFB',
        );
      setApp({
        ...appData,
        feature_flags: {
          ...appData?.feature_flags,
          NEW_SIMULATOR_ENABLED: {
            isActive: true,
          },
        },
      });
    });
  }, []);

  if (!app) {
    return (
      <LoadingContainer>
        <Spinner />
      </LoadingContainer>
    );
  }

  return <AppContext.Provider value={app}>{children}</AppContext.Provider>;
};

export const useAppContext = () => {
  const context = useContext(AppContext);

  if (context === undefined) {
    throw new Error('useAppContext must be used within a AppContextProvider');
  }
  return context;
};
